import { Controller } from "@hotwired/stimulus";

export class TogglesController extends Controller {
  static targets = ["toggle", "activeIcon", "inactiveIcon"];
  static values = { active: { type: Boolean, default: true } };

  static animationTime = 0;

  toggle() {
    this.activeValue = !this.activeValue;

    if (this.activeValue) {
      this._activate();
    } else {
      this._deactivate();
    }

    this._dispatchToggleEvent();
  }

  _activate() {
    throw new Error("_activate method not implemented.");
  }

  _deactivate() {
    throw new Error("_deactivate method not implemented.");
  }

  _dispatchToggleEvent() {
    setTimeout(
      () => this.dispatch("toggle", { detail: { content: this.activeValue } }),
      this.constructor.animationTime
    );
  }
}
